// extracted by mini-css-extract-plugin
export default {"header":"Header_header__Wx9Gm","navigation":"Header_navigation__XJCOd","headerContainer":"Header_headerContainer__U0OKA"};